// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f55af81","455":"ffe30db8","644":"8e421657"}[chunkId] + ".chunk.js";
};